import { render, staticRenderFns } from "./AccountCard.vue?vue&type=template&id=6d4232ca"
import script from "./AccountCard.vue?vue&type=script&lang=js"
export * from "./AccountCard.vue?vue&type=script&lang=js"
import style0 from "./AccountCard.vue?vue&type=style&index=0&id=6d4232ca&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports